import apiClient from "../../config/apiClient";


export const fetchTransactions = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    // return await apiClient.get(`/public/portal?url=transactions?page=1&limit=12&startDate=&endDate=&status=&service_id=Date=`, {
      return await apiClient.get(`/public/portal?url=patient/${id}/transactions?page=1&limit=12&startDate=&endDate=&status=&service_id=Date=`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
